module.exports = __webpack_public_path__ + "media/images/current-position-icon-5d016df03c43bd28bc383f39bf584ee1.png";